import { eNotifyStep } from './eNotify';
import { a3Step } from './a3';
import { a4Step } from './a4';
import { a5Step } from './a5';
import { a6Step } from './a6';

export default [...eNotifyStep, ...a3Step, ...a4Step, ...a5Step, ...a6Step];
